import { useMemo } from 'react';
import { isArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';
import type {
    TileableModel,
    TileViewModel,
} from '@rocco/ui/tile-shared/view-models/tile';
import { useItemAdminData } from '~/modules/directory/hook/use-item-admin-data';
import { mapDirectoryItemAdminToTile } from '../data-mapper/directory-item-admin-to-tile';

/**
 * Hook to populate the admin data for a list of tiles, if the current user has
 * the appropriate permissions.
 * @param tiles The tiles to populate with admin data.
 */
export function useTilesAdminData<T extends TileableModel>(
    tiles: TileViewModel<T>[]
): TileViewModel<T>[] {
    const itemIDs = useMemo(() => tiles.map((tile) => tile.model.id), [tiles]);
    const adminDataMap = useItemAdminData(itemIDs);

    return useMemo(
        () =>
            tiles.map((tile) => {
                const adminData = adminDataMap[tile.model.id];
                return {
                    ...tile,
                    adminStatusInfo:
                        adminData && !isArticleTileViewModel(tile.model)
                            ? mapDirectoryItemAdminToTile(adminData)
                            : undefined,
                };
            }),
        [tiles, adminDataMap]
    );
}
